import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'glamor';
import glamorous from 'glamorous';
import DocumentTitle from 'react-document-title';
import Dialog from 'react-toolbox/lib/dialog';
import TitleBar from '../TitleBar';
import Header from '../Header';
import Footer from '../Footer';
import { version } from '../../../../../package.json';

const Container = glamorous.div({
  backgroundColor: 'var(--page-background)',
});

const Content = glamorous.div({
  maxWidth: '1140px',
  margin: '0 auto',
  padding: '0 0 40px 0',
  '@media screen and (min-width: 1440px)': {
    width: '1152px',
  },
  '@media screen and (max-width: 960px)': {
    padding: '20px',
  },
  minHeight: '70vh',
});

const defaultActions = [
  {
    label: 'Refresh',
    onClick: () => {
      window.location.reload();
    },
    style: { backgroundColor: '#00AD50' },
  },
];
const defaultDialogChildren = () => (
  <p style={{ fontSize: '16px' }}>
    This feature is not currently available. Please refresh, if this persists
    try again later or contact NFIB Member Care at 1-800-NFIB-NOW.
  </p>
);

export default class StandardPageTemplate extends React.Component {
  static propTypes = {
    defaultDocTitle: PropTypes.string,
    children: PropTypes.node,
    titleBar: PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      children: PropTypes.func,
    }),
    renderDocTitle: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    footer: PropTypes.shape({
      version: PropTypes.string,
    }),
    showMenu: PropTypes.bool,
    menuItems: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        text: PropTypes.string,
        ref: PropTypes.string,
        items: PropTypes.array,
        style: PropTypes.object,
      })
    ),
  };
  static childContextTypes = {
    setTitle: PropTypes.func,
    setSubtitle: PropTypes.func,
    setTitleChildren: PropTypes.func,
    setTitleBar: PropTypes.func,
    setDocTitle: PropTypes.func,
    activateServiceDialog: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      titleBar: Object.assign(
        {},
        {
          title: null,
          subtitle: null,
          children: null,
        },
        props.titleBar
      ),
      docTitle: props.defaultDocTitle || 'NFIB',
      serviceDialog: {
        active: false,
        actions: defaultActions,
        title: 'Service Error',
        children: defaultDialogChildren,
      },
    };
  }

  componentWillUnmount() {
    css.global('body', { backgroundColor: 'initial' });
  }

  setTitleBarProps = updatedSettings => {
    this.setState(prevState => {
      const calculatedSettings = Object.keys(
        updatedSettings
      ).reduce((acc, curr) => {
        const value = updatedSettings[curr];
        return {
          ...acc,
          [curr]: typeof value === 'function' ? value(prevState[curr]) : value,
        };
      }, {});

      return {
        ...prevState,
        titleBar: Object.assign({}, prevState.titleBar, calculatedSettings),
      };
    });
  };

  setDocTitle = docTitle => {
    if (typeof docTitle === 'string' || typeof docTitle === 'function') {
      this.setState(prevState =>
        Object.assign({}, prevState, {
          docTitle:
            typeof docTitle === 'function'
              ? docTitle(prevState.docTitle)
              : docTitle,
        })
      );
    }
  };

  activateServiceDialog = (active = true) => {
    this.setState(prevState => {
      return {
        ...prevState,
        serviceDialog: {
          ...prevState.serviceDialog,
          active,
        },
      };
    });
  };

  getChildContext = () => ({
    setTitleBar: this.setTitleBarProps,
    setTitle: title => this.setTitleBarProps({ title }),
    setSubtitle: subtitle => this.setTitleBarProps({ subtitle }),
    setTitleChildren: children => this.setTitleBarProps({ children }),
    setDocTitle: this.setDocTitle,
    activateServiceDialog: this.activateServiceDialog,
  });

  render() {
    const { children, footer, menuItems, showMenu = true } = this.props;
    const { docTitle, titleBar, serviceDialog } = this.state;
    return (
      <Container>
        <DocumentTitle title={docTitle} />
        <Header menuItems={menuItems} showMenu={showMenu} docTitle={docTitle} />
        <TitleBar {...titleBar} />
        <Content>{children}</Content>
        <Footer version={(footer && footer.version) || version} />
        <Dialog
          {...serviceDialog}
          onEscKeyDown={serviceDialog.actions[0].onClick}
        >
          {serviceDialog.children()}
        </Dialog>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/StandardPageTemplate/index.js